import React from 'react';
import Modal from './index';
import Button from '../Button';
import Loading from '../../../Global/Loading';

export default function PrintStatusModal(props) {
  const { printStatus, setPrintStatus, onPrint} = props;

  const handleClose = () => {
    if (printStatus === PRINT_STATUS.READY) setPrintStatus(PRINT_STATUS.IDLE);
  }

  const handlePrint = () => {
    setPrintStatus(PRINT_STATUS.IDLE);
    if (onPrint) onPrint();
  }

  const getContent = () => {
    if (printStatus === PRINT_STATUS.READY) {
      return <Button onClick={handlePrint}>Print</Button>
    }
    if (printStatus === PRINT_STATUS.LOADING) {
      return <Loading />
    }
  }

  return (
    <Modal isOpen={printStatus !== PRINT_STATUS.IDLE} renderCloseIcon={false} onClose={handleClose}>
      <div className='printStatusModal'>
        {getContent()}
      </div>
    </Modal>
  );
}

export const PRINT_STATUS = {
  IDLE: "IDLE",
  LOADING: "LOADING",
  READY: "READY"
}